"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlMetricsValidation = void 0;
class PaymentTerminalControlMetricsValidation {
    static isValid(entity) {
        // Validate entity.successful_online_payment_hold_count for existence and correct type.
        if (entity.successful_online_payment_hold_count == undefined)
            return false;
        if (typeof entity.successful_online_payment_hold_count !== "number")
            return false;
        // Validate entity.preauth_declined_count for existence and correct type.
        if (entity.preauth_declined_count == undefined)
            return false;
        if (typeof entity.preauth_declined_count !== "number")
            return false;
        // Validate entity.failed_preauth_payment_count for existence and correct type.
        if (entity.failed_preauth_payment_count == undefined)
            return false;
        if (typeof entity.failed_preauth_payment_count !== "number")
            return false;
        // Validate entity.offline_payment_hold_count for existence and correct type.
        if (entity.offline_payment_hold_count == undefined)
            return false;
        if (typeof entity.offline_payment_hold_count !== "number")
            return false;
        // Validate entity.successful_online_capture_payment_count for existence and correct type.
        if (entity.successful_online_capture_payment_count == undefined)
            return false;
        if (typeof entity.successful_online_capture_payment_count !== "number")
            return false;
        // Validate entity.failed_online_capture_payment_count for existence and correct type.
        if (entity.failed_online_capture_payment_count == undefined)
            return false;
        if (typeof entity.failed_online_capture_payment_count !== "number")
            return false;
        // Validate entity.successful_offline_payment_capture_count for existence and correct type.
        if (entity.successful_offline_payment_capture_count == undefined)
            return false;
        if (typeof entity.successful_offline_payment_capture_count !== "number")
            return false;
        // Validate entity.failed_offline_payment_capture_count for existence and correct type.
        if (entity.failed_offline_payment_capture_count == undefined)
            return false;
        if (typeof entity.failed_offline_payment_capture_count !== "number")
            return false;
        // Validate entity.online_capture_retry_count for existence and correct type.
        if (entity.online_capture_retry_count == undefined)
            return false;
        if (typeof entity.online_capture_retry_count !== "number")
            return false;
        // Validate entity.offline_capture_retry_count for existence and correct type.
        if (entity.offline_capture_retry_count == undefined)
            return false;
        if (typeof entity.offline_capture_retry_count !== "number")
            return false;
        return true;
    }
}
exports.PaymentTerminalControlMetricsValidation = PaymentTerminalControlMetricsValidation;
